// Gradient definitions extracted from the new design system

export const gradients = {
  // Primary gradients
  primary: 'linear-gradient(135deg, #2c5aa0 0%, #1e3a5f 100%)',
  primaryLight: 'linear-gradient(135deg, #4a7bc8 0%, #2c5aa0 100%)',

  // Glass morphism gradients
  glass: 'linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.1) 100%)',
  glassStrong: 'linear-gradient(135deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.15) 100%)',

  // Status gradients
  success: 'linear-gradient(135deg, rgba(46, 204, 113, 0.2) 0%, rgba(39, 174, 96, 0.1) 100%)',
  error: 'linear-gradient(135deg, rgba(231, 76, 60, 0.2) 0%, rgba(192, 57, 43, 0.1) 100%)',
  warning: 'linear-gradient(135deg, rgba(245, 166, 35, 0.2) 0%, rgba(230, 126, 34, 0.1) 100%)',
  info: 'linear-gradient(135deg, rgba(52, 152, 219, 0.2) 0%, rgba(155, 89, 182, 0.2) 100%)',

  // Special gradients
  siteGroup: 'linear-gradient(135deg, rgba(74, 144, 226, 0.15) 0%, rgba(155, 89, 182, 0.15) 100%)',
  siteGroupHover: 'linear-gradient(135deg, rgba(74, 144, 226, 0.25) 0%, rgba(155, 89, 182, 0.25) 100%)',

  // Neutral gradients
  neutral: 'linear-gradient(135deg, #f8f9fb 0%, #e1e8ed 100%)',
  neutralDark: 'linear-gradient(135deg, rgba(149, 165, 166, 0.15) 0%, rgba(127, 140, 141, 0.15) 100%)',

  // Header/section gradients
  headerBackground: 'linear-gradient(135deg, #2c5aa0 0%, #4a7bc8 100%)',
  sectionBackground: 'linear-gradient(135deg, #f8f9fb 0%, #e1e8ed 100%)'
};
